// Loads every city file in this folder,
// sorted by its "order" number. A new .json file here becomes a new city page.

const context = require.context("./", false, /\.json$/);

const ALL_CITIES = context
    .keys()
    .map((key) => context(key))
    .sort((a, b) => (a.order ?? 999) - (b.order ?? 999) || a.name.localeCompare(b.name));

export default ALL_CITIES;
